
export const getFormattedPrice = (value: string): string => {
  try {
    const floatValue = parseFloat(value);
    if (isNaN(floatValue) || floatValue === 0) {
      return '0,00';
    }

    value = floatValue.toString();
  } catch (exc) {
    return '';
  }
  const splitArray = value.split('.');
  const integerPart = splitArray[0] || '0';
  const decimalPart = splitArray[1] || '00';
  const decimalPartPadded = decimalPart.padEnd(2, '0').substring(0, 2);
  const formattedValue = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${formattedValue},${decimalPartPadded}`;
};


